import React from 'react';
import '../styles/pagenotfound.css'
const PageNotFound = () => {
  return (
    <section className="page_404 mt-5">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-sm-12">
            <div className="col-sm-10 col-sm-offset-1 text-center">
              <div className="four_zero_four_bg">
                <h1 className="text-center">404</h1>
              </div>
              <div className="contant_box_404">
                <h3 className="h2">The Page you are trying to access is not valid</h3>
                
                <a href="/" className="link_404">Go to Login</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageNotFound;


